var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.196,
    height: 17,
    viewBox: "0 0 16.196 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M637.357,341.714l-3.865-4.882a6.8,6.8,0,1,0-.975,1.02l3.746,4.731a.7.7,0,1,0,1.094-.869Zm-9.234-3.644a5.413,5.413,0,1,1,5.414-5.412A5.42,5.42,0,0,1,628.123,338.07Z",
    transform: "translate(-621.312 -325.847)",
    fill: "#323237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.b3391e77.svg";
export { ForwardRef as ReactComponent };